import { render, staticRenderFns } from "./SyncIncome.vue?vue&type=template&id=c51057e6"
import script from "./SyncIncome.vue?vue&type=script&lang=js"
export * from "./SyncIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports